import JsBarcode from 'jsbarcode'

export default {

    print(etiqueta) {

        const canvas = document.createElement('canvas')

        JsBarcode(canvas, etiqueta.form.prontuario, {
            displayValue: false,
            height: 20,
            width: 1.5,
            margin: 0,
        });

        const page = window.open('', Math.random())

        let nomeSocial = etiqueta.model.cidadao.nomeSocial ? ` (${etiqueta.model.cidadao.nomeSocial})` : ''
        let unidade = etiqueta.form.unidadesReferencia
            ? etiqueta.form.unidadesReferencia.find(unidade => unidade.id == etiqueta.model.unidadeId)
            : null
        let domicilio = etiqueta.model.cidadao.domicilio ?? null
        let endereco = domicilio ? domicilio.endereco : null
        let logradouro = endereco ? endereco.logradouro : null
        let municipio = logradouro && logradouro.municipio ? logradouro.municipio.nome : 'Não informado'

        let documentos = etiqueta.model.cidadao.documentos ?? null
        let nis = documentos && documentos.carteiraTrabalho ? documentos.carteiraTrabalho.nisPisPasep : null

        page.document.write(`
            <head>
                <title>Etiqueta</title>

                <style>
                    * {
                        font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                    }
                    .content {
                        align-items: center;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }
                    .paper {
                        width: 7.8cm;
                    }
                    .container {
                        display: flex;
                        flex-direction: column;
                        padding: 0 0.1cm;
                    }
                    #header {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: flex-start;
                    }
                    #left-col {
                        flex-grow: 1;
                        padding-top: 5px;
                    }
                    #right-col {
                        font-size: 0.3cm;
                        text-align: center;
                        width: 3.3cm;
                        padding-top: 5px;
                        align-self: flex-start;
                    }
                    #prontuario{
                        font-size: 0.4cm;
                    }
                    #footer{
                        width: 10cm;
                        clear: both;
                        font-weight: normal;
                    }
                    h1 {
                        background-color: #000000;
                        color: #FFFFFF;
                        font-size: 0.25cm;
                        margin: 0;
                        padding: 0.10cm;
                        text-align: center;
                    }
                    p {
                        font-size: 0.25cm;
                        margin: 0.05cm 0;
                        padding: 0;
                    }
                    #nis {
                        margin-left: 5px;
                    }
                </style>
            </head>

            <body>
                <div class="content">
                    <div class="paper">
                        <h1>${etiqueta.model.cidadao.nome} <span>${nomeSocial}</span></h1>

                        <div class="container">
                            <div id="header">
                                <div id="left-col">
                                    <p><strong>CNS:</strong> ${etiqueta.model.cidadao.cns || ''}</p>
                                    <p><strong>DATA NASC.:</strong> ${etiqueta.dataNascimento || ''}</p>
                                    <p><strong>SEXO:</strong> ${etiqueta.sexo || ''} <span id="nis"><strong>NIS:</strong> ${nis || ''}</span></p>
                                    <p><strong>MUN. RES:</strong> ${municipio}</p>
                                </div>
                                <div id="right-col">
                                    <p><strong>PRONTUÁRIO Nº:</strong><br>
                                    <span id="prontuario"><strong>${etiqueta.form.prontuario}</strong</span>
                                    </p>

                                    <div id="barcode"></div>
                                </div>
                            </div>
                            <div id="footer">
                                <p>${unidade ? unidade.nomeFantasia : ''}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        `)

        if (etiqueta.form.prontuario) {
            page.document.getElementById('barcode').appendChild(canvas)
        }

        page.print()
        page.close()
    },
}

